var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "yxtbiz-qs-random" },
    [
      _c(
        "yxt-button",
        {
          attrs: { size: "large", type: "primary" },
          on: { click: _vm.handleClick },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.$t("pc_biz_ote_lbl_quickques"))),
          _c("yxt-svg", {
            staticClass: "v-mid ml4 mb2",
            attrs: {
              width: "14px",
              height: "14px",
              "icon-class": _vm.handleClickVal ? "arrow-up" : "arrow-down",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.handleClickVal,
              expression: "handleClickVal",
            },
          ],
          staticClass: "yxtbiz-qs-random__content",
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingBtn,
                  expression: "loadingBtn",
                },
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "yxtbiz-qs-random__line yxtbiz-qs-random__line-bgColor",
                },
                [
                  _c(
                    "span",
                    { staticClass: "yxtbiz-qs-random__line-span pl0-i" },
                    [_vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_questiontype")))]
                  ),
                  _c(
                    "span",
                    { staticClass: "yxtbiz-qs-random__line-span-input pl0-i" },
                    [_vm._v(_vm._s(_vm.$t(_vm.QUES_LEVEL_NAMES[0])))]
                  ),
                  _c(
                    "span",
                    { staticClass: "yxtbiz-qs-random__line-span-input pl0-i" },
                    [_vm._v(_vm._s(_vm.$t(_vm.QUES_LEVEL_NAMES[1])))]
                  ),
                  _c(
                    "span",
                    { staticClass: "yxtbiz-qs-random__line-span-input pl0-i" },
                    [_vm._v(_vm._s(_vm.$t(_vm.QUES_LEVEL_NAMES[2])))]
                  ),
                ]
              ),
              _vm._l(_vm.quesList, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "yxtbiz-qs-random__line mt4" },
                  [
                    _c("span", { staticClass: "yxtbiz-qs-random__line-span" }, [
                      _vm._v(_vm._s(item.type)),
                    ]),
                    _c(
                      "span",
                      { staticClass: "yxtbiz-qs-random__line-span-input" },
                      [
                        _c("yxt-input-number", {
                          staticClass: "yxtbiz-qs-random__input-number",
                          attrs: {
                            "controls-position": "right",
                            min: 0,
                            max: _vm.quesMaxInut(item.val[0]),
                            size: "mini",
                            step: 1,
                            "step-strictly": "",
                          },
                          model: {
                            value: item.num1,
                            callback: function ($$v) {
                              _vm.$set(item, "num1", $$v)
                            },
                            expression: "item.num1",
                          },
                        }),
                        _vm._v(
                          "\n          ≤ " +
                            _vm._s(_vm.quesMaxMethod(item.val[0]))
                        ),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      { staticClass: "yxtbiz-qs-random__line-span-input" },
                      [
                        _c("yxt-input-number", {
                          staticClass: "yxtbiz-qs-random__input-number",
                          attrs: {
                            "controls-position": "right",
                            min: 0,
                            max: _vm.quesMaxInut(item.val[1]),
                            size: "mini",
                            step: 1,
                            "step-strictly": "",
                          },
                          model: {
                            value: item.num2,
                            callback: function ($$v) {
                              _vm.$set(item, "num2", $$v)
                            },
                            expression: "item.num2",
                          },
                        }),
                        _vm._v(
                          "\n          ≤ " +
                            _vm._s(_vm.quesMaxMethod(item.val[1]))
                        ),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      { staticClass: "yxtbiz-qs-random__line-span-input" },
                      [
                        _c("yxt-input-number", {
                          staticClass: "yxtbiz-qs-random__input-number",
                          attrs: {
                            "controls-position": "right",
                            min: 0,
                            max: _vm.quesMaxInut(item.val[2]),
                            size: "mini",
                            step: 1,
                            "step-strictly": "",
                          },
                          model: {
                            value: item.num3,
                            callback: function ($$v) {
                              _vm.$set(item, "num3", $$v)
                            },
                            expression: "item.num3",
                          },
                        }),
                        _vm._v(
                          "\n          ≤ " +
                            _vm._s(_vm.quesMaxMethod(item.val[2]))
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _c(
            "yxt-row",
            { staticClass: "yxtbiz-qs-random__select-btn mt16" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "", disabled: _vm.loadingBtn },
                  on: { click: _vm.handleCancel },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_cancle")))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary", disabled: _vm.loadingBtn },
                  on: { click: _vm.handleConfirm },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pc_biz_ote_btn_screen")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }